var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { SACheckbox } from '../../checkbox/checkbox.component';
var Option = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 4px;\n  margin: 5px;\n  &:focus {\n    outline: none;\n  }\n  &.SASelectOptionHighlighted {\n    background: ", ";\n\n    outline: none;\n  }\n  * {\n    pointer-events: none;\n  }\n"], ["\n  border-radius: 4px;\n  margin: 5px;\n  &:focus {\n    outline: none;\n  }\n  &.SASelectOptionHighlighted {\n    background: ", ";\n\n    outline: none;\n  }\n  * {\n    pointer-events: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.slate100;
});
export var SASelectOption = React.forwardRef(function (_a, ref) {
    var children = _a.children, value = _a.value, selectedProp = _a.selected, onClick = _a.onClick, onKeyDown = _a.onKeyDown, onBlur = _a.onBlur, rest = __rest(_a, ["children", "value", "selected", "onClick", "onKeyDown", "onBlur"]);
    var _b = useState(selectedProp), selected = _b[0], setSelected = _b[1];
    var handleClick = function (e) {
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    var handleKeyDown = function (e) {
        console.log('keydown');
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    };
    useEffect(function () {
        setSelected(selectedProp);
    }, [selectedProp]);
    return (React.createElement(Option, __assign({ role: "option", "data-value": value, "aria-selected": selected, onClick: handleClick, tabIndex: selected ? 0 : -1, onKeyDown: handleKeyDown, onBlur: onBlur, ref: ref }, rest),
        React.createElement(SACheckbox, { checked: selected, id: "value", label: value, hideLabel: true, tabIndex: -1 }),
        children));
});
SASelectOption.defaultProps = {
    selected: false,
    onClick: undefined,
    onKeyDown: undefined,
};
SASelectOption.displayName = 'SASelectOption';
var templateObject_1;
//# sourceMappingURL=select-option.component.js.map